<template>
	<v-container fluid>
		<v-row>
			<v-col>
				<v-card>
					<v-card-title>
						<v-row>
							<v-col>
								<v-icon
									icon="$gavel"
									start
								/>
								<translate>
									Roles and Permissions
								</translate>
							</v-col>
							<v-col class="d-flex justify-end">
								<v-btn
									variant="outlined"
									href="#users-table"
								>
									<v-icon icon="$arrowDown" />
									<translate>Go To Users</translate>
								</v-btn>
							</v-col>
						</v-row>
					</v-card-title>
					<v-card-text>
						<role-permissions
							:admin="admin"
							:developer="developer"
						/>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
		<v-row
			id="users-table"
		>
			<v-col>
				<v-card>
					<v-card-title>
						<v-row>
							<v-col>
								<v-icon
									icon="$users"
									start
								/>
								<translate>
									Users
								</translate>
							</v-col>
							<v-col class="d-flex justify-end">
								<v-btn
									variant="outlined"
									href="#top"
								>
									<v-icon
										start
										icon="$arrowUp"
									/>
									<translate>Go To Roles & Permissions</translate>
								</v-btn>
							</v-col>
						</v-row>
					</v-card-title>
					<v-card-text>
						<user-roles />
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import RolePermissions from '../../../organisms/RolePermissions.vue';
import UserRoles from '../../../organisms/UserRoles.vue';
export default {
	name: 'RolesEdit',

	components: {
		UserRoles,
		RolePermissions
	},
	props: {
		admin: {
			type: Boolean,
			required: false,
			default: false,
		},
		developer: {
			type: Boolean,
			required: false,
			default: false,
		}
	}
};
</script>

<style scoped>

</style>
